import { useEffect, useState } from 'react';

const workerOptions = {
  OggOpusEncoderWasmPath:
    'https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/OggOpusEncoder.wasm',
  WebMOpusEncoderWasmPath:
    'https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/WebMOpusEncoder.wasm',
};

async function requestRecorder() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const options = { mimeType: 'audio/wav' };
  // @ts-ignore
  return new MediaRecorder(stream, options, workerOptions);
}

export const useRecorder = (onReadyAudioFile) => {
  const [recorder, setRecorder] = useState(null);

  const handleData = (e) => {
    const audioBlob = new Blob([e.data]);
    const file = new File([audioBlob], 'lastrecord.wav');
    onReadyAudioFile(file);
  };

  useEffect(() => {
    recorder?.addEventListener('dataavailable', handleData);
    return () => {
      recorder?.removeEventListener('dataavailable', handleData);
    };
  }, [recorder, onReadyAudioFile]);

  const startRecording = () => {
    if (!recorder) {
      const newRecord = async () => {
        const _recorder = await requestRecorder();
        setRecorder(_recorder);
        _recorder.start();
      };

      newRecord();
    } else {
      recorder.start();
    }
  };

  const stopRecording = () => {
    recorder && recorder.stop();
  };

  return { startRecording, stopRecording };
};
